import { InjectionToken } from '@angular/core';

export const IS_MOBILE = new InjectionToken<boolean>('IS_MOBILE');

// Server-only, read from the process env at runtime: an `environment` value would
// be compiled into the browser bundle and disclose the internal hostname.
export const INTERNAL_API_URL = new InjectionToken<string>('INTERNAL_API_URL');
